import { EventHandler } from '@n7-frontend/core';

export class UserMenuEH extends EventHandler {
  public listen() {
    this.innerEvents$.subscribe(({type, payload}) => {
      if(type === 'user-menu.click'){
        this.emitOuter('click', payload);
      }
    });
  }
}